import { t } from "@travily/i18n";

// Every key is spelled out rather than interpolated: i18n-tasks only sees
// static `t` calls, and a dynamic key would fail the build as unused.
//
// Shared by the disclosure panel, which names the factors a ranking weighs, and
// the per-result explanation, which names the ones that placed a destination.
// A factor the manifest declares before its copy lands falls back to its key
// rather than rendering blank.
export function factorLabel(factor: string): string {
  const labels: Record<string, string> = {
    air_quality: t("components.views.destinations.ranking.factors.air_quality"),
    climate_precipitation: t("components.views.destinations.ranking.factors.climate_precipitation"),
    climate_sunshine: t("components.views.destinations.ranking.factors.climate_sunshine"),
    climate_temperature: t("components.views.destinations.ranking.factors.climate_temperature"),
    cost: t("components.views.destinations.ranking.factors.cost"),
    english: t("components.views.destinations.ranking.factors.english"),
    enrichment: t("components.views.destinations.ranking.factors.enrichment"),
    health_environment: t("components.views.destinations.ranking.factors.health_environment"),
    healthcare_access: t("components.views.destinations.ranking.factors.healthcare_access"),
    kid_infrastructure: t("components.views.destinations.ranking.factors.kid_infrastructure"),
    peer_density: t("components.views.destinations.ranking.factors.peer_density"),
    popularity: t("components.views.destinations.ranking.factors.popularity"),
    safety: t("components.views.destinations.ranking.factors.safety"),
    visa: t("components.views.destinations.ranking.factors.visa"),
    walkability: t("components.views.destinations.ranking.factors.walkability"),
    worldschool_fit: t("components.views.destinations.ranking.factors.worldschool_fit"),
  };
  return labels[factor] ?? factor;
}
